module.exports = __webpack_public_path__ + "static/img/Send3.f033ed7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Send3.png
// module id = 84kN
// module chunks = 0